module.exports = __webpack_public_path__ + "prod/1.42.2/img/sina.38b90f3b.svg";